import * as React from 'react';
import { IYandexAddressObject } from 'api/geocoder-yandex';

export interface IYandexAddressItemProps {
    item: IYandexAddressObject;
    onClick: (item: IYandexAddressObject) => any;
}
export interface IYandexAddressItemState {}

class YandexAddressItemComponent extends React.Component<IYandexAddressItemProps, IYandexAddressItemState> {
    constructor(props: IYandexAddressItemProps) {
        super(props);

        this.onItemClick = this.onItemClick.bind(this);
    }

    onItemClick() {
        this.props.onClick(this.props.item);
    }

    render() {
        let { item } = this.props;
        return (
            <div
                className='yandex-address-search-item'
                onClick={this.onItemClick}
            >
                <div className='ya-name'>{item.GeoObject.name}</div>
                <div className='ya-description'>{item.GeoObject.description}</div>
            </div>
        );
    }
}

export const YandexAddressItem = YandexAddressItemComponent;
